import { ProgramContext } from '@rhg/providers/program';
import { useContext } from 'react';

/** Uses context from the closest <ProgramProvider> */
export function useProvidedProgramContext() {
    return useContext(ProgramContext);
}
